module.exports = __webpack_public_path__ + "static/sport/bgi-pc.d31dc17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/trea/bgi-pc.jpg
// module id = hH2y
// module chunks = 0